import { Expose } from "class-transformer";

export class UpdateNotificationDto {
  @Expose()
  isRead: boolean;
}
